// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"71540201","160":"8fea6c00","208":"89d41072","239":"da0c229c","293":"203090a8","516":"ae546a83","519":"87c74eee","732":"ae63bd84","906":"6f1f608a","917":"c5b3f665","946":"42c44740","977":"76df8cb0"}[chunkId] + ".chunk.js";
};